module.exports = __webpack_public_path__ + "static/img/bgred.4ae98cb5.png";